<template>
    <div>
        <form-people-item
            v-for="person in people"
            :key="person.id"
            :person="person"
        />
    </div>
</template>

<script>
import FormPeopleItem from "../people/FormPeopleItem";

export default {
    name: "FormSubmittablePeople",
    components: {
        FormPeopleItem,
    },
    props: {
        people: {
            type: Array,
            required: true,
        },
    },
}
</script>
